module.exports = __webpack_public_path__ + "static/media/card-bot.e2b35ce2.svg";